<template>
<div>
  <vue-headful :title="site_title" />
  <div class="awards_page">
    <template v-if="response">
      <template v-if="response.awards.length > 0">
        <table>
          <th>Название награды</th>
          <th>Награда</th>
          <th>Наградил</th>
          <th>За какие заслуги</th>
          <tr v-for="award in response.awards">
            <td>{{htmlDecode(award.awardtitle)}}</td>
            <td><img :src="'html/awards/' + award.awardimg" /></td>
            <td>{{htmlDecode(award.who_awarded)}}</td>
            <td>{{htmlDecode(award.description)}}</td>
          </tr>
        </table>
      </template>
      <template v-else>Наград нет</template>
    </template>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      response: null
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let memberId = 0;
    if (this.$route.query.id) {
      memberId = this.$route.query.id;
    }
    let response = await fetch(this.getNodePath() + 'misc/awards/' + memberId);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    console.timeEnd("PageLoadTime");
  }
}
</script>

<style lang="scss">
.awards_page {
    font-size: 11px;
    text-align: center;
    table {
        background-color: #20194b;
        margin-top: 10px;
    }
    th {
        background-color: #1b153b;
        padding: 8px 5px;
        vertical-align: middle;
    }
    td {
        padding: 10px;
    }
}
</style>
